import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '../../fourcomply-dashboard/src/app/app.component';
import { appConfig } from './app/app.config';
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

declare global {
  interface Window {
    Intercom: any;
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err: unknown): void => console.log(err)); // eslint-disable-line no-console
